import { action } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { inject, bind } from '../../../../utils/decorators';
import { BpsReferenzkraftKalibrierungRili2021Store } from '../../../../stores/BpsReferenzkraftKalibrierungRili2021Store';
import * as ApiTypesBps from '../../../../models/ApiTypesBps2021';
import { Table, FormControl, InputGroup } from 'react-bootstrap';

/**
 * Exportierte Komponente für die Erfassung der Vorbelastung eines einzelnen Rollensatzes
 */
@observer
export default class BpsReferenzkraftVorbelastungRolle extends React.Component<{ ziel: ApiTypesBps.IBpsReferenzkraftRollensatz; }, {}> {

  @inject(BpsReferenzkraftKalibrierungRili2021Store) store: BpsReferenzkraftKalibrierungRili2021Store;

  @bind @action handleWertAnzeigeChanged(index: number, ev: React.FormEvent<FormControl>) {
    this.props.ziel.vorbelastung.messpunkte[index].anzeige = (ev.target as HTMLInputElement).value !== '' ? (ev.target as HTMLInputElement).valueAsNumber : null;
  }

  @bind @action handleWertNormalChanged(index: number, ev: React.FormEvent<FormControl>) {
    this.props.ziel.vorbelastung.messpunkte[index].normal = (ev.target as HTMLInputElement).value !== '' ? (ev.target as HTMLInputElement).valueAsNumber : null;
  }

  render() {
    const { vorbelastung } = this.props.ziel;
    return (
      <div>
        <Table striped={false} bordered={false} condensed={true} hover={false} className="bps-vorbelastung">
          <thead>
            <tr>
              <th/>
              <th>Anzeige BPS</th>
              <th>Normal</th>
            </tr>
          </thead>
          <tbody>
            {vorbelastung.messpunkte.map((mp, index) =>
              <tr key={index}>
                <td className="beschriftung">{`${index + 1}. Vorbelastung`}</td>
                <td className="messwert">
                  <InputGroup>
                    <FormControl type="number" step="1.0" onChange={(e) => this.handleWertAnzeigeChanged(index, e)} readOnly={this.store.readOnly} value={mp.anzeige !== null ? mp.anzeige : ''}/>
                    <InputGroup.Addon>N</InputGroup.Addon>
                  </InputGroup>
                </td>
                <td className="messwert">
                  <InputGroup>
                    <FormControl type="number" step="1.0" onChange={(e) => this.handleWertNormalChanged(index, e)} readOnly={this.store.readOnly} value={mp.normal !== null ? mp.normal : ''}/>
                    <InputGroup.Addon>N</InputGroup.Addon>
                  </InputGroup>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/bps/rili2021/BpsReferenzkraftVorbelastungRolle.tsx